import React from 'react';

const ModeChanger = ({active_mode, changeActiveMode}) => {

  const modes = ['Price', 'Chance'];

  const handleOnChange = (e) => {
    changeActiveMode(e.target.value);
  }

  return (
    <div>
      <div className="flex">
        {modes.map((mode) => 
          <div key={mode} className="col-6 center">
            <label>
              <input
                type="radio"
                name="mode"
                value={mode}
                onChange={handleOnChange.bind(this)}
                checked={mode === active_mode} 
              /> {mode}
            </label>
          </div>
        )}
      </div>
    </div>
  )
}

export default ModeChanger;


/** WEBPACK FOOTER **
 ** ./src/components/ModeChanger.js
 **/